<div class="speed-tab" dir="rtl">
  <div *ngIf="loading" class="empty-box">
    <i class="fa fa-spinner fa-spin"></i>
    <span>در حال دریافت اطلاعات سرعت...</span>
  </div>

  <div *ngIf="!loading && !hasData" class="empty-box">
    <i class="fa fa-tachometer"></i>
    <span>داده‌ای برای تحلیل سرعت وجود ندارد</span>
  </div>

  <ng-container *ngIf="!loading && hasData">
    <div class="grid-2">
      <div class="box">
        <h3><i class="fa fa-bar-chart"></i> مجموع مدت زمان در بازه‌های سرعت (ثانیه) — کل ناوگان</h3>
        <div class="chart-lg"><canvas id="speedDist"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-car"></i> میانگین مدت زمان هر خودرو در بازه‌های سرعت (ثانیه)</h3>
        <div class="chart-lg"><canvas id="speedAvg"></canvas></div>
      </div>
    </div>

    <div class="grid-2 mt">
      <div class="box">
        <h3><i class="fa fa-flag"></i> مجموع نمونه‌های سرعت اوج (140+، 160+، 180+، 200+)</h3>
        <div class="chart-lg"><canvas id="peakSamples"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-clock-o"></i> مدت زمان سرعت‌های اوج (ثانیه) — 160+ و 180+</h3>
        <div class="chart-lg"><canvas id="peakDuration"></canvas></div>
      </div>
    </div>

    <div class="box mt">
      <h3><i class="fa fa-list-ol"></i> خودروهای با بیشترین مدت سرعت 120+ (ثانیه)</h3>
      <div class="tablewrap">
        <table>
          <thead>
            <tr>
              <th>ردیف</th>
              <th>خودرو / راننده</th>
              <th>پلاک</th>
              <th>80-99 ثانیه</th>
              <th>100-109 ثانیه</th>
              <th>110-119 ثانیه</th>
              <th>120+ ثانیه</th>
              <th>مجموع</th>
              <th>حداکثر سرعت</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of topSpeedRows; let i = index; trackBy: trackByRow">
              <td>{{ i + 1 }}</td>
              <td class="name">{{ x.strFullName }}</td>
              <td>{{ x.strVehicleNo }}</td>
              <td>{{ x.Speed80Seconds }}</td>
              <td>{{ x.Speed100Seconds }}</td>
              <td>{{ x.Speed110Seconds }}</td>
              <td class="red"><b>{{ x.Speed120Seconds }}</b></td>
              <td>{{ x.speedTotal }}</td>
              <td>{{ x.MaxSpeed }}</td>
            </tr>
            <tr *ngIf="!topSpeedRows.length">
              <td colspan="9" class="empty-cell">رکوردی یافت نشد</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
